(() => {
  const placeholders = {
    de: 'Rolex Ersatzteil suchen...',
    en: 'Search Rolex spare part...',
    fr: 'Rechercher une piece Rolex...',
    it: 'Cerca ricambio Rolex...',
    es: 'Buscar repuesto Rolex...',
    'pt-pt': 'Pesquisar peca Rolex...',
    'zh-cn': 'Sousuo Rolex peijian...',
    ja: 'Rolex no bubin o kensaku...',
    nl: 'Zoek Rolex onderdeel...',
    pl: 'Szukaj czesci Rolex...',
    ru: 'Poisk detali Rolex...',
    cs: 'Hledat dil Rolex...',
    da: 'Sog Rolex-reservedel...',
    fi: 'Hae Rolex-varaosaa...',
    no: 'Sok Rolex-del...',
    sv: 'Sok Rolex-del...',
    ko: 'Rolex bupum geomsaek...',
    ar: 'ابحث عن قطعة غيار Rolex...'
  };

  const localeKey = () => {
    const lang = (document.documentElement.lang || 'de').toLowerCase();
    if (lang.startsWith('pt')) return 'pt-pt';
    if (lang.startsWith('zh')) return 'zh-cn';
    return lang;
  };

  const ensureRuntimeStyle = () => {
    if (document.getElementById('oysterquartz-banner-runtime-fix')) return;
    const style = document.createElement('style');
    style.id = 'oysterquartz-banner-runtime-fix';
    style.textContent = `
      .section--oysterquartz-banner {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin: 0 !important;
        background: transparent !important;
        overflow: visible !important;
      }
      .section--oysterquartz-banner .oysterquartz-banner {
        display: block !important;
        margin: 0 !important;
        isolation: isolate !important;
      }
      .section--oysterquartz-banner .oysterquartz-banner__media {
        overflow: hidden !important;
      }
      .section--oysterquartz-banner .oysterquartz-banner__button,
      .section--oysterquartz-banner .oysterquartz-banner__button:hover,
      .section--oysterquartz-banner .oysterquartz-banner__button:focus,
      .section--oysterquartz-banner .oysterquartz-banner__button:focus-visible {
        border: 0 !important;
        outline: 0 !important;
        box-shadow: none !important;
      }
      .section--oysterquartz-banner .oysterquartz-banner__button::before,
      .section--oysterquartz-banner .oysterquartz-banner__button::after,
      .section--oysterquartz-banner .reset__button.field__button,
      .section--oysterquartz-banner .reset__button.field__button::before,
      .section--oysterquartz-banner .reset__button.field__button::after,
      .section--oysterquartz-banner .predictive-search__loading-state,
      .section--oysterquartz-banner .spinner {
        display: none !important;
        content: none !important;
        border: 0 !important;
        box-shadow: none !important;
      }
    `;
    document.head.appendChild(style);
  };

  const applyDropdownStyles = (root) => {
    root.querySelectorAll('.oysterquartz-banner__predictive, .oysterquartz-banner__predictive .predictive-search').forEach((node) => {
      node.style.background = 'linear-gradient(180deg, rgba(255, 255, 255, 0.88) 0%, rgba(248, 244, 236, 0.82) 100%)';
      node.style.border = '1px solid rgba(213, 187, 119, 0.3)';
      node.style.boxShadow = '0 1.8rem 4rem rgba(0, 0, 0, 0.24), 0 0 0 1px rgba(41, 122, 93, 0.24)';
      node.style.backdropFilter = 'blur(10px)';
    });
    root.querySelectorAll('.predictive-search__loading-state, .spinner').forEach((node) => node.remove());
  };

  const applyToBanner = (root) => {
    ensureRuntimeStyle();
    const placeholder = placeholders[localeKey()] || placeholders.de;
    const heading = root.querySelector('.oysterquartz-banner__heading');
    if (heading) heading.style.display = 'none';

    const section = root.closest('.section--oysterquartz-banner');
    if (section) {
      section.style.paddingTop = '0';
      section.style.paddingBottom = '0';
      section.style.margin = '0';
      section.style.background = 'transparent';
      section.style.overflow = 'visible';
    }

    root.style.margin = '0';
    root.style.display = 'block';
    root.style.isolation = 'isolate';

    const media = root.querySelector('.oysterquartz-banner__media');
    if (media) media.style.overflow = 'hidden';

    const input = root.querySelector('.search__input.field__input');
    if (input) {
      input.placeholder = placeholder;
      input.setAttribute('aria-label', placeholder);
    }

    const resetButton = root.querySelector('.reset__button.field__button');
    if (resetButton) resetButton.style.display = 'none';

    root.querySelectorAll('.oysterquartz-banner__button').forEach((button) => {
      button.style.border = '0';
      button.style.outline = '0';
      button.style.boxShadow = 'none';
    });

    applyDropdownStyles(root);

    const predictive = root.querySelector('.oysterquartz-banner__predictive');
    if (predictive && !predictive.dataset.bannerFixObserved) {
      predictive.dataset.bannerFixObserved = 'true';
      new MutationObserver(() => applyDropdownStyles(root)).observe(predictive, { childList: true, subtree: true });
    }
  };

  const init = () => {
    document.querySelectorAll('.section--oysterquartz-banner').forEach(applyToBanner);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', init);
})();

/* time-legal-footer:start */
(() => {
  const ensureFooterRuntimeStyle = () => {
    if (document.getElementById('time-legal-footer-runtime-style')) return;
    const style = document.createElement('style');
    style.id = 'time-legal-footer-runtime-style';
    style.textContent = `
      .shopify-section-group-footer-group .footer-block--menu .footer-block__details-content {
        width: auto !important;
        justify-content: center !important;
        gap: 0.95rem !important;
        align-items: baseline !important;
      }
      .shopify-section-group-footer-group .footer__localization {
        justify-content: center !important;
        gap: 0.95rem !important;
        align-items: baseline !important;
        margin-left: 0.2rem !important;
      }
      .shopify-section-group-footer-group .footer__localization .localization-form__select,
      .shopify-section-group-footer-group .footer__localization .disclosure__button {
        min-width: 0 !important;
        width: auto !important;
        padding: 0 1.15rem 0 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        font-size: 1.05rem !important;
        letter-spacing: 0.06em !important;
        text-transform: uppercase !important;
        outline: 0 !important;
        appearance: none !important;
        -webkit-appearance: none !important;
      }
      .shopify-section-group-footer-group .footer__localization .localization-form__select::before,
      .shopify-section-group-footer-group .footer__localization .localization-form__select::after {
        display: none !important;
        content: none !important;
        box-shadow: none !important;
        border: 0 !important;
      }
      .shopify-section-group-footer-group .footer__content-bottom-wrapper {
        justify-content: center !important;
        gap: 1.2rem !important;
        width: auto !important;
        align-items: baseline !important;
      }
    `;
    document.head.appendChild(style);
  };

  const compactFooterLocalization = (section) => {
    const countryForm = section.querySelector('#FooterCountryForm');
    const languageForm = section.querySelector('#FooterLanguageForm');

    const currentCountry = countryForm?.querySelector('#FooterCountry-country-results .disclosure__link[aria-current="true"]');
    const countryCode = (currentCountry?.dataset.value || 'DE').trim().toUpperCase();
    const currencyText = currentCountry?.querySelector('.localization-form__currency')?.textContent || '';
    const currencyMatch = currencyText.match(/[A-Z]{3}/);
    const currencyCode = currencyMatch ? currencyMatch[0] : 'EUR';
    const countryButtonText = countryForm?.querySelector('.localization-form__select span');
    if (countryButtonText) {
      countryButtonText.textContent = `${countryCode} | ${currencyCode}`;
    }

    const localeInput = languageForm?.querySelector('input[name="locale_code"]');
    const localeCode = ((localeInput?.value || document.documentElement.lang || 'de').split('-')[0] || 'de').toUpperCase();
    const languageButtonText = languageForm?.querySelector('.localization-form__select span');
    if (languageButtonText) {
      languageButtonText.textContent = localeCode;
    }
  };

  const initFooterLegal = () => {
    ensureFooterRuntimeStyle();
    document.querySelectorAll('.shopify-section-group-footer-group').forEach(compactFooterLocalization);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterLegal, { once: true });
  } else {
    initFooterLegal();
  }

  window.addEventListener('pageshow', initFooterLegal);
})();
/* time-legal-footer:end */

